import React, {createContext, ReactNode, useContext, useMemo} from 'react';
import {placement_header} from "../components/page_layouts/pageLayoutsUtils";
import {CmCollectionType, PageGridPlacementType} from "../components/types";
import type {Page} from "../routing/types";

export interface PageContextType {
    page: Page,
    siteId: string,
    taxonomies: string[],
    rootUrl: string,
    searchEnabled: boolean,
    hideTopNavi: boolean,
    chatbotEnabled: boolean,
    isMobileUserAgent: boolean
}

interface Props {
    children: ReactNode
    page: Page
    siteId: string
    rootUrl: string
    taxonomies: string[]
    isMobileUserAgent?: boolean
}

export const PageContext = createContext<PageContextType>({} as PageContextType);
const usePageContext = () => useContext(PageContext)

const PageProvider = (props: Props) => {
    const searchEnabled = props.page?.searchSettings?.["searchEnabled"] || false;
    const header = props.page?.grid?.placements?.find((p: PageGridPlacementType) => p.name === placement_header);
    const topNavi = header?.items?.find((cmCol: CmCollectionType) => cmCol.viewtype === "asTopNavi") as CmCollectionType;
    const topNaviItems = topNavi?.items ?? [];
    const hideTopNavi = topNaviItems.length === 0 && !searchEnabled;
    const chatbotEnabled = props.page?.chatbotEnabled || false;

    const contextValue = useMemo(() => ({
        page: props.page,
        siteId: props.siteId,
        rootUrl: props.rootUrl,
        taxonomies: props.taxonomies,
        searchEnabled: searchEnabled,
        hideTopNavi: hideTopNavi,
        chatbotEnabled: chatbotEnabled,
        isMobileUserAgent: !!props.isMobileUserAgent
    }), [props.page, props.siteId, props.rootUrl, props.taxonomies, searchEnabled, hideTopNavi, chatbotEnabled,
        props.isMobileUserAgent]);

    return (
        <PageContext.Provider
            value={contextValue}>
            {props.children}
        </PageContext.Provider>
    );
}

export {
    usePageContext,
    PageProvider
}
